import React from "react";
import {
  FaShieldAlt,
  FaClock,
  FaSnowflake,
  FaHandshake,
  FaUsers,
  FaLeaf,
} from "react-icons/fa";
import "./OurValuesSection.css";

const OurValuesSection = () => {
  const values = [
    {
      icon: <FaShieldAlt />,
      title: "Safety First",
      desc: "Every bus is CCTV monitored and every driver is vetted and trained.",
    },
    {
      icon: <FaClock />,
      title: "Reliability",
      desc: "We show up on time, every time — that's our promise to every rider.",
    },
    {
      icon: <FaSnowflake />,
      title: "Comfort",
      desc: "Air-conditioned buses with assigned seats — no standing, no stress.",
    },
    {
      icon: <FaHandshake />,
      title: "Integrity",
      desc: "Transparent pricing, no cash on buses, and honest communication.",
    },
    {
      icon: <FaUsers />,
      title: "Community",
      desc: "We build lasting relationships with every worker who rides with us.",
    },
    {
      icon: <FaLeaf />,
      title: "Sustainability",
      desc: "Fewer vehicles on the road means a greener, cleaner commute for all.",
    },
  ];

  return (
    <section className="staffline-values-section">
      <div className="container">

        {/* ===== HEADER ===== */}
        <div className="staffline-values-header">
          <span className="staffline-values-tag">Our Values</span>
          <h2 className="staffline-values-title">
            The Principles That Drive Us
          </h2>
          <p className="staffline-values-desc">
            Our values aren't just words on a page — they shape every decision,
            every route, and every ride.
          </p>
        </div>

        {/* ===== VALUES GRID ===== */}
        <div className="staffline-values-grid">
          {values.map((value, i) => (
            <div className="staffline-values-card" key={i}>
              <div className="staffline-values-icon">{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OurValuesSection;